import { ROUTES } from 'constants/routes';
import FileManagement from '@components/file-management';
import EmployeeManagementFilter from '@components/filters/employee-management';

import { employeeManagementListColumns } from './list-data';
import { useEffect, useState } from 'react';

import { StaffStatus, SubscriptionType } from 'types';
import { getEmployeeManagementList } from 'shared/helpers/employee-management/get-employee-management-list';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkPayloadObject } from 'shared/helpers/checkPayloadObject';

type listDataType = {
  page: number;
  size: number;
  sortName: string;
  sortType: 'asc' | 'dsc' | '';
  schStaffSt: StaffStatus | '';
  staffSchGroup: 'sch_name' | 'sch_email' | 'sch_name_email' | '';
  schKeyword: string;
  staffMstList:
  | [
    {
      joinTp: SubscriptionType;
      regDt: string;
      userEmail: string;
      userName: string;
      userSeq: string;
      userSt: StaffStatus;
      userUid: string;
    },
  ]
  | [];
  totalCount: number;
};

const EmployeeManagementViewPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setLoading] = useState<boolean>(false)
  const initialData: listDataType = {
    page: 1,
    size: 10,
    sortName: '',
    sortType: '',
    schStaffSt: '',
    staffSchGroup: '',
    schKeyword: '',
    staffMstList: [],
    totalCount: 0,
  }
  const [listData, setListData] = useState<listDataType>(initialData);

  useEffect(() => {
    const isRefresh = location?.state?.refresh
    const fetchData = async () => {
      setLoading(true)
      await getEmployeeManagementList(initialData,
        // @ts-ignore
        [{ key: 'page', value: 1 }, { key: 'schStaffSt', value: '' }, { key: 'schKeyword', value: '', }, { key: 'staffSchGroup', value: 'sch_name' }],
        setListData,
        ['page', 'schStaffSt', 'schKeyword', 'staffSchGroup'])
      setLoading(false)
    }

    if (isRefresh) {
      fetchData()
    }
  }, [location?.state])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await getEmployeeManagementList(listData, [], setListData, []);
      setLoading(false)
    }
    fetchData()
  }, []);

  return (
    <FileManagement
      isLoading={isLoading}
      title="마크애니 직원 관리"
      linkStack={[
        {
          label: 'Home',
          path: ROUTES.EMPLOYEE_MANAGEMENT.ROOT,
        },
        {
          label: '마크애니 직원 관리',
          path: ROUTES.EMPLOYEE_MANAGEMENT.ROOT,
        },
      ]}
      Filter={
        <EmployeeManagementFilter
          isLoading={isLoading}
          getFilteredList={async (payload) => {
            setLoading(true)
            await getEmployeeManagementList(listData, payload, setListData, [
              'page',
              'schStaffSt',
              'staffSchGroup',
              'schKeyword',
            ])
            if (!checkPayloadObject(payload)) {
              navigate(
                ROUTES.EMPLOYEE_MANAGEMENT.ROOT,
                { state: { page: payload[0].value, notEmpty: true } }
              )
            }
            setLoading(false)
          }}
        />
      }
      isCreateAction={false}
      type="EMPLOYEE_MANAGEMENT"
      listData={{
        columns: employeeManagementListColumns,
        rows: listData?.staffMstList?.map((item, index) => {
          return {
            id:
              listData.totalCount - (listData.page - 1) * listData.size - index,
            ...item,
          };
        }),
        totalCount: listData.totalCount,
        page: listData.page,
        pageSize: listData.size,
      }}
      getFilteredList={(payload) =>
        getEmployeeManagementList(listData, payload, setListData, [
          'sortName',
          'sortType',
        ])
      }
      handlePagination={async (payload) => {
        await getEmployeeManagementList(listData, payload, setListData, ['page'])
        if (!checkPayloadObject(payload)) {
          navigate(
            ROUTES.EMPLOYEE_MANAGEMENT.ROOT,
            { state: { page: payload[0].value, notEmpty: true } }
          )
        }
      }}
    />
  );
};

export default EmployeeManagementViewPage;
